import { Component } from '@angular/core';

@Component({
	selector: 'lib-adl-campaign-management-library-internal',
	template: `
		<p>
			<lib-campaign-management></lib-campaign-management>
		</p>
	`,
})
export class AdlCampaignManagementLibraryInternalComponent {}
